var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',[(_setup.user)?_c('div',{staticClass:"card"},[_c('h4',[_vm._v("NOMBRE: "+_vm._s(_setup.user.name))]),_c('h4',[_vm._v("CORREO: "+_vm._s(_setup.user.email))]),_c('h4',[_vm._v("ROL:")]),_c('ul',_vm._l((_setup.user.roles),function(rol){return _c('li',{key:rol.id},[_vm._v(_vm._s(rol.nombre))])}),0)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }